import { handleMessage } from "../utils";
import Properties from "../../../properties";

export const INTERFACE_GERAL_PREFIX = "interface.geral.";

const GERAL = {
  geral: {
    data: ["{0}/{1}/{2}", "{2}-{1}-{0}"],
    emConstrucao: ["Página em desenvolvimento!", "Page under construction!"],
    footer: [
      "© " + new Date().getFullYear() + " - Sistema de Licença de Pesca",
      "© " + new Date().getFullYear() + " - Fishing Licence System"
    ],
    confirmar: ["Confirmar", "Confirm"],
    cancelar: ["Cancelar", "Cancel"],
    sucesso: ["Sucesso", "Success"],
    validacao: {
      titulo: ["Aviso", "Notice"],
      resumoVarios: [
        "Há pendências no formulário. Confira os campos indicados.",
        "There are issues in the form. Please check the highlighted fields."
      ]
    },
    erro: {
      titulo: ["Erro", "Error"],
      mensagem: [
        "Não foi possível concluir a operação. Tente novamente.",
        "The operation could not be completed. Please try again."
      ]
    }
  }
};

export const PT_GERAL = handleMessage(GERAL, Properties.LANGUAGE_INDEX.PT_BR);
export const EN_GERAL = handleMessage(GERAL, Properties.LANGUAGE_INDEX.EN);
